<template>

    <v-container fluid fill-height>
        <v-layout>

            <v-flex>

                <v-card>

                    <v-breadcrumbs divider="/">
                        <v-breadcrumbs-item to="/" :disabled="false">Početna</v-breadcrumbs-item>
                        <v-breadcrumbs-item to="/attributes" :exact="true" :disabled="false">Pod grupe</v-breadcrumbs-item>
                        <v-breadcrumbs-item :disabled="true">Izmena</v-breadcrumbs-item>
                    </v-breadcrumbs>

                </v-card>

                <v-card class="fix-card">

                    <form>

                        <v-text-field
                                v-model="attribute.title"
                                :error="error_messages.title == false"
                                :error-messages="error_messages.title"
                                label="Naziv"
                                required
                        ></v-text-field>

                        <v-select
                                v-if="properties"
                                :items="properties"
                                label="Grupa"
                                v-model="attribute.property_id"
                                :error="error_messages.property_id == false"
                                :error-messages="error_messages.property_id"
                                item-text="title"
                                item-value="id"
                        ></v-select>

                        <v-text-field
                                v-model="attribute.order"
                                :error="error_messages.order == false"
                                :error-messages="error_messages.order"
                                label="Redosled"
                        ></v-text-field>

                        <v-checkbox
                                label="Vidljivo"
                                v-model="attribute.is_visible"
                                color="primary"
                        ></v-checkbox>

                        <v-btn @click="submit()" color="primary">Potvrdi</v-btn>
                        <v-btn @click="clear()" color="secondary" class="black--text">Očisti</v-btn>

                    </form>

                </v-card>

            </v-flex>

            <v-fab-transition>

                <v-btn :color="'primary'" dark fab fixed bottom right to="/users/create">
                    <v-icon>playlist_add</v-icon>
                    <v-icon>close</v-icon>
                </v-btn>

            </v-fab-transition>

        </v-layout>

    </v-container>

</template>

<script>
    import swal from 'sweetalert2';

    export default {
        data () {
            return {
                fillable: ['title', 'slug', 'property_id', 'order', 'is_visible',],
                attribute: {},
                properties: false,
                error_messages: [],
            }
        },
        mounted(){
            this.getProperties();
        },
        computed: {
            userProfile(){
                return this.$store.getters['user/getUser'];
            },
        },
        methods: {
            getAttribute(){
                axios.get('attributes/' + this.$route.params.id)
                    .then(res => {
                      this.attribute = res.data.attribute;
                    })
                    .catch(e => {
                        console.log(e);
                        this.error = e.response.data.errors;
                    });
            },
          getProperties(){
            axios.get('properties/lists')
              .then(res => {
                this.properties = res.data.properties;
                this.getAttribute();
              })
              .catch(e => {
                console.log(e);
                this.error = e.response.data.errors;
              });
          },
            submit(){
                let data = fillForm(this.fillable, this.attribute, 'PUT');
                axios.post(`attributes/${this.attribute.id}`, data)
                    .then( res => {
                        // this.attribute = res.data.attribute;
                        swal({
                            position: 'center',
                            type: 'success',
                            title: 'Uspeh',
                            showConfirmButton: false,
                            timer: 1500
                        });
                    })
                    .catch( e => {
                        console.log(e.response.data);
                        this.error_messages = e.response.data;
                    });
            },
            clear(){
              this.attribute.title = '';
              this.attribute.property_id = '';
              this.attribute.order = '';
              this.attribute.is_visible = false;
              this.error_messages = [];
            },
        }
    }
</script>
